import React, { lazy, ReactNode, Suspense } from 'react';

const Slider = lazy(() => import('./index.lazy'));

const renderLoader = () => <p>Loading</p>;

interface SliderProps {
  children?: ReactNode;
  noBootstrap?: boolean;
  captions?: (string | undefined)[];
}

const SliderSuspense: React.FC<SliderProps> = (props) => (
  <Suspense fallback={renderLoader()}>
    <Slider {...props} />
  </Suspense>
);

export default SliderSuspense;
